import { useRegion } from "../hooks/useRegion.js";
import { useCurrentUserRegions } from "../../AppWrapper2/hooks/useCurrentUserRegions.js";
import React, { useContext } from "react";
import { Loading } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx } from "react/jsx-runtime";
//#region src/modules/Regions/contexts/RegionContext.tsx
var RegionContext = React.createContext(void 0);
var RegionContextProvider = ({ children, LoadingComponent, regionId }) => {
	if (!regionId) return /* @__PURE__ */ jsx(Fragment$1, { children });
	const { data, loading, refresh } = useRegion({ regionId });
	if (!data?.region) return LoadingComponent ? /* @__PURE__ */ jsx(LoadingComponent, {}) : /* @__PURE__ */ jsx(Loading, {
		message: "Loading Region",
		overlay: true
	});
	return /* @__PURE__ */ jsx(RegionContext.Provider, {
		value: {
			loading,
			refresh,
			region: data?.region,
			regionId
		},
		children
	});
};
function useRegionContext() {
	const ctx = useContext(RegionContext);
	const { currentRegion, selectedRegions } = useCurrentUserRegions();
	if (selectedRegions.length > 1 && !ctx) return void 0;
	if (!ctx) {
		if (!currentRegion) return void 0;
		return {
			region: currentRegion,
			regionId: currentRegion.id
		};
	}
	return ctx;
}
//#endregion
export { RegionContext, RegionContextProvider, useRegionContext };

//# sourceMappingURL=RegionContext.js.map